import React, {Component} from 'react';
import Col from 'react-bootstrap/Col';
import { Link } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import FastQuotingDoorDataService from "./services/fastquotingdoor.service";
import * as FaIcons from "react-icons/fa";
import { Button, Container, FormControl, FormLabel } from 'react-bootstrap';
import FastQuotingDoorsList from './FastQuotingDoorsList';

var newDate = new Date()
var gtDate = newDate.getDate().toString().padStart(2,'0') + '-' + (newDate.getMonth()+1).toString().padStart(2,'0') + '-' + newDate.getFullYear()

class DoorFastQuote extends Component {

  constructor(props) {
    super(props);
    this.onChangeDoorFastQuoteFilterByDescr = this.onChangeDoorFastQuoteFilterByDescr.bind(this);
    this.onChangeSortField = this.onChangeSortField.bind(this);
    this.onChangeSortType = this.onChangeSortType.bind(this);
    this.performSearch = this.performSearch.bind(this);

    this.state = {
      listOfCabinetFastQuotes: null,
      DoorFastQuoteFilterByDescr: '',
      SortField: 'id',
      SortType: 'ASC'
    };
  }  

  onChangeSortType() {
    this.setState({
      SortType: (this.state.SortType == 'DESC')?'ASC':'DESC'
    });
    this.performSearch(this.state.DoorFastQuoteFilterByDescr,this.state.SortField,this.state.SortType);    
  }

  onChangeSortField(e) {
    this.setState({
      SortField: e.target.value
    });
    this.performSearch(this.state.DoorFastQuoteFilterByDescr,e.target.value,this.state.SortType);
  }

  onChangeDoorFastQuoteFilterByDescr(e) {
    this.setState({
        DoorFastQuoteFilterByDescr: e.target.value
    });
    this.performSearch(e.target.value,this.state.SortField,this.state.SortType);
  }

  componentDidMount() {
    this.performSearch(this.state.DoorFastQuoteFilterByDescr, this.state.SortField,this.state.SortType);  
  }

  performSearch = (descr,sortfield,sorttype) => {
    FastQuotingDoorDataService.getfastquotingdoorByDescr(descr,sortfield,sorttype)
      .then(response => {
        console.log(response.data);
        this.setState({
          listOfFastQuotingDoors: response.data
        });
        console.log(this.state.listOfFastQuotingDoors);
      })
      .catch(e => {
        console.log(e);
      });
  };

  searchWithEnter = (event)=> {
    if (event.keyCode === 13) {
      this.performSearch();
    }
  }  

  render (){
    return (
      <>
      <Container style={{width:"80%"}}>
        <Row className='mb-2 d-flex'>
          <FormLabel style={{fontSize:"0.8em",textAlign:"right"}}>Current Date: {gtDate}</FormLabel>
          <hr/>
          <h4 className='mb-4' style={{width: "100%", textAlign: "center", marginLeft: "0%", color: "green" }}>Door Fast Quotes</h4>
          <Col lg={true}>
            <FormLabel className='mb-2'>Filter by Quoting number:</FormLabel>       
            <FormControl type="text" name="filterbyquotingnumber" id="filterbyquotingnumber" onChange={this.onChangeDoorFastQuoteFilterByDescr}></FormControl>
          </Col>
          <Col lg={true}>
            <FormLabel className='mb-2'>Sort By:</FormLabel>       
              <FormControl as='select' onChange={this.onChangeSortField}>
                <option value="id">Quoting Number</option>
                <option value="job.jobtitle">Job Name</option>
              </FormControl>
          </Col>
          
          <Col sm={true}>
            <FormLabel className='mb-2'>Asc/Desc:</FormLabel>       
            <FormControl style={{maxWidth:"50px"}} as="button" onClick={this.onChangeSortType}><FaIcons.FaSortAmountDownAlt/></FormControl>
          </Col>          
        </Row>
        <Link to="/new-door-fast-quote" className="mr-2 btn btn-primary">New Door Fast Quote</Link>            
        <Button className="m-2 btn btn-primary">Export</Button>        
        <Row>
          <FastQuotingDoorsList mode={0} listOfFastQuotingDoors = {this.state.listOfFastQuotingDoors} />      
        </Row>
      </Container>
      </>
    )
  }
}

export default DoorFastQuote;